/* Route guards + layouts for the portal area (no marketing chrome). */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/portal/auth/AuthContext';
import { PortalDataProvider } from '@/portal/data/PortalDataContext';

function PortalLoading() {
  return (
    <div className="portal">
      <div className="pl-login">
        <p style={{ color: 'var(--ink-faint)' }}>Loading…</p>
      </div>
    </div>
  );
}

/** Wraps the whole portal area in the auth context. */
export function AuthLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

/** Authenticated-only (used for the standalone change-password page). */
export function RequireAuthBare() {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === 'loading') return <PortalLoading />;
  if (status === 'anon') return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return <Outlet />;
}

/** Authenticated workspace: forces a password change when flagged, and loads
    the portal data store for its children. */
export function RequireAuth() {
  const { status, mustChangePassword } = useAuth();
  const loc = useLocation();
  if (status === 'loading') return <PortalLoading />;
  if (status === 'anon') return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (mustChangePassword && loc.pathname !== '/portal/change-password') {
    return <Navigate to="/portal/change-password" replace />;
  }
  return (
    <PortalDataProvider>
      <Outlet />
    </PortalDataProvider>
  );
}

/** If already signed in, keep the login page from showing. */
export function RedirectIfAuthed() {
  const { status } = useAuth();
  if (status === 'loading') return <PortalLoading />;
  if (status === 'authed') return <Navigate to="/portal" replace />;
  return <Outlet />;
}
